<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/trainRecord2'}">培训</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <div style="margin-top: 20px;">
                <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        label-width="130px"
                        class="demo-ruleForm"
                        style="width:60%;margin:0 auto"
                        size="small"
                >
                    <el-form-item label="计划名称" prop="courseName">
                        <el-input v-model="ruleForm.courseName"></el-input>
                    </el-form-item>
                    <el-form-item label="计划年度" prop="planYear">
                        <!-- <el-date-picker
                          v-model="ruleForm.planYear"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          type="datetime"
                          placeholder="选择日期"
                          style="width: 100%"
                        /> -->
                        <el-date-picker
                                v-model="ruleForm.planYear"
                                type="year"
                                value-format="yyyy"
                                placeholder="选择年">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="培训类型" prop="cultivateType">
                        <el-select v-model="ruleForm.cultivateType" placeholder="培训类型" style="width: 100%">
                            <el-option v-for="item1 in cultivateTypeList" :key="item1.id" :value="item1.id"
                                       :label="item1.name"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="培训课时（小时）" prop="duration">
                        <el-input v-model="ruleForm.duration" type="number"/>
                    </el-form-item>
                    <el-form-item label="培训单位" prop="organizationName">
                        <el-input v-model="ruleForm.organizationName" placeholder="培训单位"/>
                    </el-form-item>
                    <el-form-item label="培训部门" prop="organizationDepName">
                        <el-input v-model="ruleForm.organizationDepName" placeholder="培训部门"/>
                    </el-form-item>
                    <el-form-item label="培训讲师" prop="teacher">
                        <el-input v-model="ruleForm.teacher" placeholder="培训讲师"/>
                    </el-form-item>
                    <el-form-item label="培训地点" prop="place">
                        <el-input v-model="ruleForm.place" placeholder="培训地点"/>
                    </el-form-item>
                    <el-form-item label="培训资料" prop="legislationIds">
                        <el-select v-model="ruleForm.legislationIds" placeholder="请选择" multiple style="width: 100%"
                                   @change="legislationChange">
                            <el-option v-for="item2 in trainingMaterialsList" :key="item2.id" :value="item2.id"
                                       :label="item2.materialName"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="培训简介" prop="contentHtml">
                        <el-input v-model="ruleForm.contentHtml" type="textarea" :rows="3"/>
                    </el-form-item>
                    <el-form-item label="参加人员" prop="cultivateEmp">
                        <el-select v-model="ruleForm.cultivateEmp" @change="staffChange" multiple style="width: 100%">
                            <el-option v-for="staff in staffList" :key="staff.id" :value-key="staff.id"
                                       :value="staff.id" :label="staff.name"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="参加人数" prop="turnout">
                        <el-input v-model="ruleForm.turnout" type="number"/>
                    </el-form-item>
                    <el-form-item label="及格分数" prop="passMark">
                        <el-input v-model="ruleForm.passMark" type="number"/>
                    </el-form-item>
                    <el-form-item label="培训费用（单位：元）" prop="trainingCost">
                        <el-input v-model="ruleForm.trainingCost" type="number"/>
                    </el-form-item>
                    <el-form-item label="实施日期" prop="estStartTime">
                        <el-date-picker
                                v-model="ruleForm.estStartTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetime"
                                placeholder="选择日期"
                                style="width: 100%"
                        />
                    </el-form-item>
                    <el-form-item label="完成日期" prop="estEndTime">
                        <el-date-picker
                                v-model="ruleForm.estEndTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetime"
                                placeholder="选择日期"
                                style="width: 100%"
                        />
                    </el-form-item>
                    <el-form-item label="考核单位" prop="assessDepName">
                        <el-input v-model="ruleForm.assessDepName" placeholder="考核单位"/>
                    </el-form-item>
                    <el-form-item label="编制部门" prop="editorDepId">
                        <el-select v-model="ruleForm.editorDepId" placeholder="请选择" @change="editorDepChange"
                                   style="width: 100%">
                            <el-option v-for="item3 in depData" :key="item3.id" :value="item3.id" :label="item3.name"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="编制人" prop="editorEmpId">
                        <el-select v-model="ruleForm.editorEmpId" placeholder="请选择" style="width: 100%"
                                   @change="editorChange">
                            <el-option v-for="item in userData" :key="item.id" :label="item.name" :value="item.id"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="制定时间" prop="createTime">
                        <el-date-picker
                                v-model="ruleForm.createTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetime"
                                placeholder="选择日期"
                                style="width: 100%"
                        />
                    </el-form-item>
                    <el-form-item label="实际开始时间">
                        <el-date-picker
                                v-model="ruleForm.actualStartTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetime"
                                placeholder="选择日期"
                                style="width: 100%"
                        />
                    </el-form-item>
                    <el-form-item label="实际结束时间">
                        <el-date-picker
                                v-model="ruleForm.actualEndTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetime"
                                placeholder="选择日期"
                                style="width: 100%"
                        />
                    </el-form-item>
                    <el-form-item label="" style="margin-top: 40px">
                        <el-button type="primary" class="addBtn" @click="submitForm()" style="width: 100%">保存
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getAllDepartment, getDepartUser, trainMaterialsList, cultivateAdd,
        cultivateEdit, getEmpBindUser
    } from '@/api/processManager';

    export default {
        data() {
            return {
                isAdd: true,
                cultivateTypeList: [
                    {id: 1, name: '入司培训'},
                    {id: 2, name: '转岗培训'},
                    {id: 3, name: '复岗培训'},
                    {id: 4, name: '取证培训'},
                    {id: 5, name: '日常培训'},
                ],
                // 培训资料
                trainingMaterialsList: [],
                ruleForm: {
                    legislationIds: []
                },
                rules: {
                    courseName: [{required: true, message: '请输入计划名称'}],
                    planYear: [{required: true, message: '请选择'}],
                    cultivateType: [{required: true, message: '请选择'}],
                    duration: [{required: true, message: '情书日培训课时'}],
                    organizationName: [{required: true, message: '请输入培训单位'}],
                    organizationDepName: [{required: true, message: '请输入培训部门'}],
                    teacher: [{required: true, message: '请输入培训讲师'}],
                    place: [{required: true, message: '请输入培训地点'}],
                    legislationIds: [{required: true, message: '请选择培训资料'}],
                    contentHtml: [{required: true, message: '请输入培训简介'}],
                    cultivateEmp: [{required: true, message: '请选择参加人员', trigger: 'blur'}],
                    turnout: [{required: true, message: '请输入参加人数'}],
                    passMark: [{required: true, message: '请输入及格分数'}],
                    trainingCost: [{required: true, message: '请输入培训费用'}],
                    estStartTime: [{required: true, message: '请选择'}],
                    estEndTime: [{required: true, message: '请选择'}],
                    assessDepName: [{required: true, message: '请输入考核单位'}],
                    editorDepId: [{required: true, message: '请选择编制部门'}],
                    editorEmpId: [{required: true, message: '请选择编制人'}],
                    createTime: [{required: true, message: '请选择'}],
                    actualStartTime: [{required: true, message: '请选择'}],
                    actualEndTime: [{required: true, message: '请选择'}]
                },
                // 部门列表
                depData: [],
                // 部门下面的人员
                userData: [],
                // 员工列表
                staffList: []
            };
        },
        mounted() {
            this.getDepart();
            this.getTrainList();
            this.getAllStaff();
            if (this.$route.params.key) {
                let obj = this.$route.params.key
                obj.legislationIds = this.$route.params.key.legislationIds.split(',')
                for (let i in obj.legislationIds) {
                    obj.legislationIds[i] = Number(obj.legislationIds[i])
                }
                let arr = []
                for (let i in obj.cultivateEmp) {
                    arr.push(obj.cultivateEmp[i].empId)
                }
                obj.cultivateEmp = arr
                this.ruleForm = {...obj}
            }
        },
        methods: {
            // 获取部门
            getDepart() {
                getAllDepartment().then(res => {
                    this.depData = res.body.data
                })
            },
            // 部门改变
            editorDepChange(id) {
                this.$set(this.ruleForm, 'editorEmpId', '')
                for (let i in this.depData) {
                    if (this.depData[i].id === id) {
                        this.ruleForm.editorDepName = this.depData[i].name
                    }
                }
                getDepartUser({demId: id}).then(res => {
                    this.userData = res.body.data
                })
            },
            // 编写人改变
            editorChange(id) {
                for (let i in this.userData) {
                    if (this.userData[i].id === id) {
                        this.ruleForm.editorEmpName = this.userData[i].name
                    }
                }
            },
            // 获取培训资料
            getTrainList() {
                trainMaterialsList({limit: 100, curPage: 1}).then(res => {
                    this.trainingMaterialsList = res.body.data
                })
            },
            // 选择培训资料改变
            legislationChange(item) {
                let arr = []
                for (let i in item) {
                    for (let j in this.trainingMaterialsList) {
                        if (item[i] === this.trainingMaterialsList[j].id) {
                            arr.push(this.trainingMaterialsList[j].materialName)
                        }
                    }
                }
                if (arr.length !== 0) {
                    this.ruleForm.legislationNames = arr.join(',')
                }
            },
            // 获取绑定了账号的员工
            getAllStaff() {
                getEmpBindUser().then(res => {
                    this.staffList = res.body.data
                })
            },
            // 员工改变
            staffChange(row) {
                this.$set(this.ruleForm, 'turnout', row.length)
            },
            // 保存
            submitForm() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        let obj = {...this.ruleForm}
                        obj.legislationIds = this.ruleForm.legislationIds.join(',')
                        let arr = this.ruleForm.cultivateEmp
                        let newArr = []
                        // 操作参加人员的数据
                        for (let i in arr) {
                            for (let j in this.staffList) {
                                if (arr[i] === this.staffList[j].id) {
                                    newArr.push(
                                        {
                                            empId: this.staffList[j].id,
                                            empName: this.staffList[j].name,
                                            userId: this.staffList[j].userId
                                        }
                                    )
                                }
                            }
                        }
                        obj.cultivateEmp = newArr
                        // 编辑
                        if (this.$route.params.key) {
                            cultivateEdit({...obj}).then(res => {
                                this.$message.success('保存成功')
                                this.$router.push('trainRecord2')
                            })
                        }
                        // 新增
                        else {
                            cultivateAdd({...obj}).then(res => {
                                this.$message.success('保存成功')
                                this.$router.push('trainRecord2')
                            })
                        }
                    } else {
                        return false;
                    }
                })
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    };
</script>

<style scoped>
    .addBtn {
        display: block;
        width: 300px;
        margin: 0 auto;
    }

    .myHead {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 160px;
    }
</style>
